export const validatePhone = (phoneNumber: string) => {
  const phoneRe = /^(1\s|1|)?((\(\d{3}\))|\d{3})(-|\s)?(\d{3})(-|\s)?(\d{4})$/;
  const digits = phoneNumber.replace(/\D/g, '');
  return phoneRe.test(digits);
};
